import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ProductDetailDto } from '../common/product-detail.dto';
import { ProductResponse } from '../common/product-response';
import { SearchCriteria } from '@shop/services/shop.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private publicApiUrl: string = `${environment.apiUrl}/products`;

  constructor(private httpClient: HttpClient) {}

  getProducts(criteria: SearchCriteria): Observable<ProductResponse> {
    let params = new HttpParams()
      .set('page', criteria.page.toString())
      .set('size', criteria.size.toString())
      .set('sort', criteria.sort || 'dateCreated,desc');

    if (criteria.searchTerm) {
      params = params.append('searchTerm', criteria.searchTerm);
    }
    if (criteria.categoryId) {
      params = params.append('categoryId', criteria.categoryId.toString());
    }
    if (criteria.minPrice) {
      params = params.append('minPrice', criteria.minPrice.toString());
    }
    if (criteria.maxPrice) {
      params = params.append('maxPrice', criteria.maxPrice.toString());
    }

    return this.httpClient.get<ProductResponse>(`${this.publicApiUrl}/search`, { params });
  }

  getProductById(id: number): Observable<ProductDetailDto> {
    return this.httpClient.get<ProductDetailDto>(`${this.publicApiUrl}/${id}`);
  }
}
